// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"749":"6bbd4864","903":"5cc4a790"}[chunkId] + ".chunk.js";
};